import { render, staticRenderFns } from "./register.vue?vue&type=template&id=0b7c2c8a&scoped=true&lang=html&"
import script from "./register.vue?vue&type=script&lang=js&"
export * from "./register.vue?vue&type=script&lang=js&"
import style0 from "./register.vue?vue&type=style&index=0&id=0b7c2c8a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7c2c8a",
  null
  
)

component.options.__file = "register.vue"
export default component.exports